import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var AHL =
/*#__PURE__*/
function (_BaseData) {
  _inherits(AHL, _BaseData);

  function AHL() {
    _classCallCheck(this, AHL);

    return _possibleConstructorReturn(this, _getPrototypeOf(AHL).call(this, "AHL"));
  }

  _createClass(AHL, [{
    key: "ChangeIncludeOnAHL",
    value: function () {
      var _ChangeIncludeOnAHL = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(propertyId, includeOnAHL) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.post("/api/".concat(this._controller, "/ChangeIncludeOnAHL/").concat(propertyId, "/").concat(includeOnAHL)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function ChangeIncludeOnAHL(_x, _x2) {
        return _ChangeIncludeOnAHL.apply(this, arguments);
      }

      return ChangeIncludeOnAHL;
    }()
  }, {
    key: "GetAllActiveProjects",
    value: function () {
      var _GetAllActiveProjects = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/GetAllActiveProjects")));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetAllActiveProjects() {
        return _GetAllActiveProjects.apply(this, arguments);
      }

      return GetAllActiveProjects;
    }()
  }, {
    key: "GetAllProjectPhotos",
    value: function () {
      var _GetAllProjectPhotos = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(userId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/GetAllProjectPhotos/").concat(userId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetAllProjectPhotos(_x3) {
        return _GetAllProjectPhotos.apply(this, arguments);
      }

      return GetAllProjectPhotos;
    }()
  }, {
    key: "GetPropertyPhotos",
    value: function () {
      var _GetPropertyPhotos = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(propertyId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/".concat(this._controller, "/GetPropertyPhotos/").concat(propertyId)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function GetPropertyPhotos(_x4) {
        return _GetPropertyPhotos.apply(this, arguments);
      }

      return GetPropertyPhotos;
    }()
  }, {
    key: "GetPhotoBase64",
    value: function () {
      var _GetPhotoBase = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(docId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/".concat(this._controller, "/GetPhotoBase64/").concat(docId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function GetPhotoBase64(_x5) {
        return _GetPhotoBase.apply(this, arguments);
      }

      return GetPhotoBase64;
    }()
  }, {
    key: "UploadFile",
    value: function () {
      var _UploadFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(files, propertyId, photoType) {
        var formData;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                formData = new FormData();
                files.forEach(function (file) {
                  formData.append("files[]", file);
                });
                return _context6.abrupt("return", axios.post("/api/".concat(this._controller, "/FileUpload/").concat(propertyId, "/").concat(photoType), formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function UploadFile(_x6, _x7, _x8) {
        return _UploadFile.apply(this, arguments);
      }

      return UploadFile;
    }()
  }, {
    key: "CreateDeniedReasonRow",
    value: function () {
      var _CreateDeniedReasonRow = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(photoId, deniedTypeId) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.post("/api/".concat(this._controller, "/CreateDeniedReasonRow/").concat(photoId, "/").concat(deniedTypeId)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function CreateDeniedReasonRow(_x9, _x10) {
        return _CreateDeniedReasonRow.apply(this, arguments);
      }

      return CreateDeniedReasonRow;
    }()
  }, {
    key: "EmailUpdate",
    value: function () {
      var _EmailUpdate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(photoId) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.post("/api/".concat(this._controller, "/EmailUpdate/").concat(photoId)));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function EmailUpdate(_x11) {
        return _EmailUpdate.apply(this, arguments);
      }

      return EmailUpdate;
    }()
  }, {
    key: "UserPropertiesMissingPhotos",
    value: function () {
      var _UserPropertiesMissingPhotos = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.get("/api/".concat(this._controller, "/UserPropertiesMissingPhotos")));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function UserPropertiesMissingPhotos() {
        return _UserPropertiesMissingPhotos.apply(this, arguments);
      }

      return UserPropertiesMissingPhotos;
    }()
  }]);

  return AHL;
}(BaseData);

export default new AHL();